import React, { useState, useEffect } from "react";
import apiCall from "../../API/API";
import { toast } from "react-toastify";
import { Row, Col, Container, Button, Form } from "react-bootstrap";

const PrincipleWithdrawalStatus = () => {
    const [currentStatusDisplay, setCurrentStatusDisplay] = useState("Loading..."); 
    const [desiredStatus, setDesiredStatus] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const fetchPrincipleWithdrawalStatus = async () => {
        setIsLoading(true);
        try {
            const { data, error } = await apiCall("GET", "/get-company-info");
            if (data) {
                const fetchedStatus = data.company_info.principal_withdrawal_status;
                setCurrentStatusDisplay(fetchedStatus === 1 ? "Active" : "Inactive");
                setDesiredStatus(fetchedStatus === 1 ? true : false);
            } else if (error) {
                toast.error(error.message || "Failed to fetch status.");
                setCurrentStatusDisplay("Error");
            }
        } catch (e) {
            console.error("Error fetching principle withdrawal status:", e);
            toast.error("Failed to fetch principle withdrawal status.");
            setCurrentStatusDisplay("Error");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPrincipleWithdrawalStatus();
    }, []);

    const handleUpdateStatus = async () => {
        setIsLoading(true);
        try {
            const body = {
                status: desiredStatus ? 1 : 0,
            };
            console.log("Updating principle withdrawal status with body:", body);

            const { data, error } = await apiCall("POST", `/update-principal-withdraw`, body); 
            
            if (error) {
                toast.error(error.message || "An error occurred while updating status.");
            } else {
                toast.success(data.message || "Principle withdrawal status updated successfully!");
                fetchPrincipleWithdrawalStatus(); 
            }
        } catch (error) {
            console.error("Error during status update:", error);
            toast.error(error.message || "An error occurred during update.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Container className="mt-4">
                <section id="principal-withdrawal-section">
                    <div className="d-flex justify-content-center">
                        <h2>Principal Withdrawal Status</h2>
                    </div>
                    <section id="formContent">
                        <div className="form">
                            <Row>
                                <Col lg={6} style={{ margin: "auto" }}>
                                    <form onSubmit={(e) => { e.preventDefault(); handleUpdateStatus(); }}>
                                        <div id="formFields">
                                            <div className="mb-3">
                                                <label>Current Status:</label>
                                                <Form.Control
                                                    type="text"
                                                    value={currentStatusDisplay}
                                                    readOnly
                                                    disabled
                                                    className="form-control-plaintext"
                                                />
                                            </div>

                                            {/* Toggle for Desired Status */}
                                            <div className="mb-3" style={{ marginTop: '20px' }}>
                                                <label>Set New Status:</label>
                                                <Form.Check
                                                    type="switch"
                                                    id="principal-withdrawal-status-switch"
                                                    label={desiredStatus ? "Active" : "Inactive"}
                                                    checked={desiredStatus}
                                                    onChange={(e) => setDesiredStatus(e.target.checked)}
                                                />
                                            </div>

                                            <Button 
                                                type="submit" 
                                                variant="primary" 
                                                disabled={isLoading}
                                            >
                                                Update Status
                                            </Button>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </div>
                    </section>
                </section>
            </Container>
        </React.Fragment>
    );
};

export default PrincipleWithdrawalStatus;